import gql from 'graphql-tag';

export const GET_CUSTOMER_DETAILS = gql`
  query GetCustomerDetails($customerAccountId: ID!) {
    customer {
      customerDetails(customerAccountId: $customerAccountId) {
        error
        success
        entity {
          accountId
          name
          address
          phone
          firstContactDate
          lastContactDate
          lastSaleDate
          status
          totalRevenueAmount
          opportunitiesNumber
          activeOpportunitiesNumber
        }
      }
    }
  }
`;
